import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { ActivePromo } from '../schemas/promos';
import { listOf } from '../schemas/utils';

const headers = { 'Key-Inflection': 'camel' };

export const activePromosQueryKey = () => ['promos:active'];

const activePromosPath = '/promos/active';

// Lists the promos the current user is currently eligible to see.
export const useActivePromos = (options?: { enabled?: boolean }) => {
	const http = useHttpClient('v2');

	return useQuery({
		queryKey: activePromosQueryKey(),
		queryFn: async (): Promise<ActivePromo[]> => {
			const res = await http.get<{ result: unknown[] }>(activePromosPath, { headers });
			return listOf(ActivePromo).parse(res.data.result ?? []);
		},
		enabled: options?.enabled ?? true,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
};
